import { createStyles, makeStyles } from '@material-ui/core/styles';
import { PRIMARY, SECONDARY } from 'constants/colors';
export default makeStyles(theme => createStyles({
  overviewCard: {
    minWidth: '50px',
    overflow: 'clip',
    aspectRatio: '1.3',
    borderRadius: theme.spacing(0.5),
    border: '1px solid rgba(0, 0, 0, 0.12)',
    maxHeight: '250px',
    '& > .MuiCardContent-root': {
      height: '100%',
      minHeight: '125px',
      padding: 0
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: '50% 50%',
      transition: '.4s',
      pointerEvents: 'none'
    },
    '&:hover img': {
      transition: '.4s',
      filter: 'blur(1px) contrast(0.9)',
      transform: 'scale(1.1)',
      pointerEvents: 'none'
    },
    '& svg': {
      transition: '.2s',
      transform: 'translateX(0px)',
      marginRight: '-20px',
      opacity: '0%'
    },
    '&:hover svg': {
      transition: '.2s',
      transform: 'translateX(10px)',
      marginRight: '-4px',
      opacity: '100%'
    }
  },
  overviewCardLabel: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    zIndex: 999,
    background: PRIMARY,
    color: SECONDARY,
    padding: '6px 20px',
    borderRadius: '0 4px 4px 0',
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)'
  }
}));